import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FiHome, FiChevronRight } from 'react-icons/fi';

const Breadcrumb = ({ customPath }) => {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(segment => segment);

  // Define breadcrumb mappings
  const breadcrumbMap = {
    'category': 'Categories',
    'section': 'Sections',
    'guestbook': 'Guest Book',
    'search': 'Search',
    'admin': 'Admin',
    'dashboard': 'Dashboard',
    'categories': 'Categories',
    'sections': 'Sections',
    'settings': 'Settings',
    'qr-codes': 'QR Codes',
    'login': 'Login',
    // Category slugs
    'welcome': 'Welcome',
    'av-technology': 'AV & Technology',
    'house-operations': 'House Operations',
    'rooms-spaces': 'Rooms & Spaces',
    'transportation': 'Transportation',
    'local-info': 'Local Information',
    'house-rules': 'House Rules',
    'emergency': 'Emergency',
    // Common section slugs
    'quick-info': 'Quick Info',
    'streaming-logins': 'Logins',
    'hot-tub': 'Hot Tub',
    'fireplace': 'Fireplace',
    'car-info': 'Car Information',
    'ski-access': 'Ski Access',
    'restaurants': 'Restaurants',
    'indian-room': 'Indian Room',
    'bear-room': 'Bear Room',
    'antler-room': 'Antler Room'
  };

  // If custom path is provided (for QR code access), use it
  const breadcrumbs = customPath || [];

  // Otherwise, build from URL
  if (!customPath) {
    let path = '';
    pathSegments.forEach((segment, index) => {
      path += `/${segment}`;
      
      // Skip certain segments
      if (segment === 'category' || segment === 'section') {
        return;
      }

      // Get display name
      const displayName = breadcrumbMap[segment] || 
        segment.split('-').map(word => 
          word.charAt(0).toUpperCase() + word.slice(1)
        ).join(' ');

      breadcrumbs.push({
        name: displayName,
        path: path
      });
    });
  }

  // Don't show breadcrumb on home page or if only one level deep
  if (breadcrumbs.length === 0 || (breadcrumbs.length === 1 && !customPath)) {
    return null;
  }

  return (
    <nav className="mb-6">
      <ol className="flex items-center space-x-2 text-sm">
        {/* Home link */}
        <li>
          <Link 
            to="/" 
            className="text-mountain-gray-500 hover:text-lodge-brown-600 transition-colors"
            aria-label="Home"
          >
            <FiHome className="w-4 h-4" />
          </Link>
        </li>

        {/* Breadcrumb items */}
        {breadcrumbs.map((crumb, index) => (
          <React.Fragment key={crumb.path || index}>
            <li className="text-mountain-gray-400">
              <FiChevronRight className="w-4 h-4" />
            </li>
            <li>
              {index === breadcrumbs.length - 1 ? (
                // Current page (not a link)
                <span className="text-mountain-gray-700 font-medium">
                  {crumb.name}
                </span>
              ) : (
                // Parent pages (links)
                <Link
                  to={crumb.path}
                  className="text-mountain-gray-500 hover:text-lodge-brown-600 transition-colors"
                >
                  {crumb.name}
                </Link>
              )}
            </li>
          </React.Fragment>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;